__turbopack_context__.v({
  "actions": "topbar-module-scss-module__OS728G__actions",
  "brand": "topbar-module-scss-module__OS728G__brand",
  "nav": "topbar-module-scss-module__OS728G__nav",
  "root": "topbar-module-scss-module__OS728G__root",
});
